export const getQueryParam = (paramName) => {
  const url = window.location.href;
  const urlObject = new URL(url);
  const queryParams = new URLSearchParams(urlObject.search);

  let paramValue = queryParams.get(paramName);

  if (!paramValue) {
    return null;
  }

  try {
    paramValue = decodeURIComponent(paramValue);
  } catch (e) {
    return paramValue;
  }

  try {
    return JSON.parse(paramValue);
  } catch (e) {
    return paramValue;
  }
};
